import React from "react";
import { FaPlus } from "react-icons/fa";
import ModalPortal from "components/ModalPortal";
import {X} from "lucide-react"

export default function CreateRequest({ onClose, onCreateMR, onCreateRFQ, onCreatePO }) {
  return (
    <ModalPortal>
      <div className="fixed inset-0 z-50 flex items-center justify-center">
        {/* Backdrop */}
        <div className="absolute inset-0 bg-black/40" onClick={onClose} />

        {/* Modal */}
        <div className="relative w-full max-w-xl bg-white rounded-2xl shadow-xl mx-4">
          {/* Header */}
          <div className="flex items-center justify-center py-4 border-b border-gray-100">
            <h2 className="text-xl font-medium text-[#232323]">Create Request</h2>
            <button
              onClick={onClose}
              className="absolute right-4 top-4 w-8 h-8 rounded-full flex items-center justify-center text-gray-600 hover:bg-gray-100"
              aria-label="Close"
            >
              <X size={20}/>
            </button>
          </div>

          {/* Body */}
          <div className="p-5">
            <OptionRow
              title="Material Request"
              onClick={onCreateMR}
            />
            <OptionRow
              title="Request for Quotation (RFQ)"
              onClick={onCreateRFQ}
            />
            <OptionRow
              title="Purchase Order (PO)"
              onClick={onCreatePO}
            />
          </div>
        </div>
      </div>
    </ModalPortal>
  );
}

function OptionRow({ title, onClick }) {
  return (
    <button
      onClick={onClick}
      className="w-full flex items-center justify-between px-4 py-4 rounded-lg bg-[#F5EEF9] text-[#3B0069] mb-3 border border-[#E7D9F0] hover:bg-[#EFE4F5]"
    >
      <span className="text-sm font-medium">{title}</span>
      <span className="w-6 h-6 rounded-full bg-[#3B0069] flex items-center justify-center">
        <FaPlus size={14} className="text-white"/>
      </span>
    </button>
  );
}


